import { TmrItem } from 'stylewhere/api'
import { config } from 'stylewhere/config'

const DESK_NOTICE_SSE_CHANNEL = 'perimeterMonitoring'

export interface DeskNoticeTagRead {
  identifierCode: string
}

export interface DeskNoticeEvent {
  sourceCode?: string
  placeId?: string
  operationdate?: string
  tagReads?: DeskNoticeTagRead[]
  attributes?: Record<string, string>
}

export type DeskNoticeDecodeResult = { [identifierCode: string]: TmrItem | null }

export class DeskNotice {
  static getSseEndpoint(placeId: string): string {
    const endpoint = config.endpoint.endsWith('/') ? config.endpoint.slice(0, -1) : config.endpoint
    return `${endpoint}/api/v1/sse/getData/${DESK_NOTICE_SSE_CHANNEL}/${placeId}`
  }
}
